export class ContactForm {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    ipAddress: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/models/contact-form.model.ts